import { getLoadablePage } from 'site-modules/shared/components/loadable-page/loadable-page';
import { create404Error } from 'site-modules/shared/utils/errors';

export const routes = [
  {
    path: `/shopper-profile`,
    exact: true,
    page: getLoadablePage((params, store) => {
      const { featureFlags } = store.getState();

      if (!featureFlags?.['core-shopper-profiles']) {
        throw create404Error('Page not found');
      }

      return import(/* webpackChunkName: "shopper-profile" */ '../pages/shopper-profile/shopper-profile-definition');
    }),
    chunkName: 'shopper-profile',
    resolveLocationInParallelToPagePreload: true,
  },
];
